<template>
  <nav v-if="isAdminSection">
    <div class="navbar navbar--admin">
      <router-link class="navbar-element" to="/admin">Portfolio</router-link>
    </div>
  </nav>

  <button
      v-if="isAdminSection && isAdminAuthenticated"
      class="icon-action icon-action--logout"
      type="button"
      title="Fermer la session admin"
      aria-label="Fermer la session admin"
      @click="logout"
  >
    <svg class="bi bi-box-arrow-right" viewBox="0 0 16 16" aria-hidden="true">
      <path fill-rule="evenodd" d="M10 15a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h7a1 1 0 0 1 1 1v3a.5.5 0 0 1-1 0V1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7v-3a.5.5 0 0 1 1 0z"/>
      <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
    </svg>
  </button>

  <nav v-else>
    <div class="navbar">
      <router-link class="navbar-element" to="/">Accueil</router-link>
      <router-link class="navbar-element" to="/cv">CV</router-link>
      <router-link class="navbar-element" to="/portfolio">Portfolio</router-link>
    </div>
  </nav>

  <div class="page-container" :class="{ 'page-container--admin': isAdminSection }">
    <router-view/>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';

import {GetRequest, PostRequest} from "@/services/request";

const route = useRoute();
const router = useRouter();
const isAdminSection = computed(() => route.path.startsWith('/admin'));
const isAdminAuthenticated = ref(false);

async function refreshAdminSession() {
  if (!isAdminSection.value) {
    isAdminAuthenticated.value = false;
    return;
  }

  try {
    const data = await GetRequest('auth/session');
    isAdminAuthenticated.value = Boolean(data?.authenticated);
  } catch (_error) {
    isAdminAuthenticated.value = false;
  }
}

async function logout() {
  if (!window.confirm('Fermer la session admin maintenant ?')) {
    return;
  }

  try {
    await PostRequest('auth/logout');
  } finally {
    isAdminAuthenticated.value = false;
    await router.push('/admin');
  }
}

watch(() => route.path, () => {
  refreshAdminSession();
}, {immediate: true});

onMounted(() => {
  refreshAdminSession();
});
</script>

<style>
body {
  background-color: #1e1f22;
  color: white;
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

nav {
  width: 100%;
  display: flex;
  justify-content: center;
}

.navbar {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 3rem;
  gap: 2rem;
  background-color: #323336;
  border-radius: 30px;
  z-index: 1000;
}

.icon-action {
  position: fixed;
  z-index: 1001;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #50545d;
  cursor: pointer;
  color: white;
  background: #252629;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.24);
  transition: transform 0.18s ease, border-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.icon-action svg {
  width: 1.35rem;
  height: 1.35rem;
  fill: currentColor;
}

.icon-action:hover {
  transform: translateY(-2px);
  border-color: #00f0ff;
  color: #00f0ff;
  box-shadow: 0 0 20px rgba(0, 240, 255, 0.25);
}

.icon-action--logout {
  top: 12px;
  right: 12px;
  width: 46px;
  height: 46px;
  border-radius: 999px;
}

.navbar-element {
  position: relative;
  font-size: 2rem;
  color: white;
  text-decoration: none;
}

.navbar-element::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: white;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.navbar-element:hover::after {
  transform: scaleX(1);
}

.page-container {
  padding-top: 70px;
  margin: 0 10px;
}

.page-container--admin {
  padding-top: 70px;
}

a {
  color: #0077ff;
}
</style>
